<template>
  <v-card
    :color="backgroundColor"
    :style="{
      color: textColor,
      overflow: 'hidden'
    }"
    :to="{ name: 'trip', params: { id: trip.id } }"
    :ripple="false"
  >
    <v-layout row>
      <v-flex xs7>
        <v-card-title>
          <div>
            <div class="display-1 text-truncate">
              {{ trip.name }}
            </div>

            <trip-dates
              class="subtitle-2 ml-6"
              :start-date="trip.startDate"
              :end-date="trip.endDate"
            />
          </div>
        </v-card-title>
      </v-flex>

      <v-flex
        xs5
        style="padding-right:7px;"
      >
        <v-img
          :src="trip.image ? trip.image : require('@/assets/images/trip-placeholder.jpg')"
          height="125px"
          cover
          :gradient="`to right, ${backgroundColor}, transparent`"
        >
          <v-container fill-height>
            <v-row style="align-self:flex-end">
              <div v-if="creator">
                by
                <v-avatar
                  v-if="creator.photoURL"
                  :size="20"
                >
                  <img :src="creator.photoURL">
                </v-avatar>
                {{ creator.displayName || creator.email }}
              </div>
            </v-row>
          </v-container>
        </v-img>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import { firestore } from '@/plugins/firebase'
import TripDates from '@/components/TripDates'

export default {
  components: {
    TripDates
  },
  props: {
    trip: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      creator: null,
      defaultBackgroundColor: '#bba87f',
      defaultTextColor: 'white'
    }
  },
  computed: {
    backgroundColor () {
      return this.trip.backgroundColor || this.defaultBackgroundColor
    },
    textColor () {
      return this.trip.textColor || this.defaultTextColor
    }
  },
  async mounted () {
    if (this.trip.createdBy !== this.$currentUser.id) {
      const doc = await firestore
        .collection('users')
        .doc(this.trip.createdBy)
        .get()

      this.creator = doc.data()
    }
  }
}
</script>
